// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"qK-z","smallCardRow":"rK-z","largeCardRow":"sK-z","productSearchRow":"tK-z","curatedRow":"uK-z"};